import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initDevelopmentForge(): void {
    const sparks = document.querySelectorAll('.code-forge__spark');
    if (sparks.length === 0) return;

    // Enhanced forge animation
    sparks.forEach((spark, i) => {
        gsap.to(spark, {
            y: '100vh',
            opacity: 0,
            duration: 2 + Math.random() * 2,
            repeat: -1,
            delay: i * 0.5,
            ease: 'none'
        });
    });
}

export function initQualityGates(): void {
    const gates = Array.from(document.querySelectorAll<HTMLElement>('.gate-item'));
    if (gates.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
        gsap.set(gates, { clearProps: 'all' });
        return;
    }

    gsap.set(gates, { autoAlpha: 0, x: 42 });

    ScrollTrigger.create({
        trigger: '.quality-gates',
        start: 'top 82%',
        once: true,
        onEnter: () => {
            gsap.to(gates, {
                autoAlpha: 1,
                x: 0,
                stagger: 0.14,
                duration: 0.72,
                ease: 'power3.out',
                onComplete: () => gsap.set(gates, { clearProps: 'opacity,visibility,transform' })
            });
        }
    });
}
